<div class="form-row m-0">
  <mat-form-field appearance="outline" class="input-bea w-100">
    <input matInput [disabled]="disabled" [value]="inputLabel" #searchTextField type="text" [placeholder]="placeholder" />
  </mat-form-field>
</div>
